import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-6" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "col-xxl-6" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "col-lg-12" }
const _hoisted_11 = { class: "col-xxl-3" }
const _hoisted_12 = { class: "col-xxl-6 col-lg-6" }
const _hoisted_13 = { class: "col-xxl-3 col-lg-6" }
const _hoisted_14 = { class: "col-lg-4 col-md-6 col-xl-6 col-xxl-4" }
const _hoisted_15 = { class: "col-lg-4 col-md-6 col-xl-6 col-xxl-4" }
const _hoisted_16 = { class: "col-lg-4 col-xl-12 col-xxl-4" }
const _hoisted_17 = { class: "col-lg-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RestaurantStatsToday = _resolveComponent("RestaurantStatsToday")!
  const _component_TotalOrdersChart = _resolveComponent("TotalOrdersChart")!
  const _component_PendingOrdersChart = _resolveComponent("PendingOrdersChart")!
  const _component_Revenue = _resolveComponent("Revenue")!
  const _component_Expense = _resolveComponent("Expense")!
  const _component_TopSellingItems = _resolveComponent("TopSellingItems")!
  const _component_RecentOrdersList = _resolveComponent("RecentOrdersList")!
  const _component_OrderSummaryChart = _resolveComponent("OrderSummaryChart")!
  const _component_RevenueExpenseChart = _resolveComponent("RevenueExpenseChart")!
  const _component_LowStockAlerts = _resolveComponent("LowStockAlerts")!
  const _component_StaffPerformanceScores = _resolveComponent("StaffPerformanceScores")!
  const _component_RevenueByBranches = _resolveComponent("RevenueByBranches")!
  const _component_Tickets = _resolveComponent("Tickets")!
  const _component_CustomerRatings = _resolveComponent("CustomerRatings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RestaurantStatsToday),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TotalOrdersChart)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_PendingOrdersChart)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Revenue)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Expense)
        ])
      ]),
      _createVNode(_component_TopSellingItems)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_RecentOrdersList)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_OrderSummaryChart)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_RevenueExpenseChart)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_LowStockAlerts)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_StaffPerformanceScores)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_RevenueByBranches)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_Tickets)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_CustomerRatings)
    ])
  ]))
}